import { ReactNode } from 'react';
import {
  ALERT_ACTION_CLASSES,
  ALERT_ICON_CLASSES,
  ALERT_MESSAGE_CLASSES,
  AlertColor,
  AlertVariant,
  alertClasses,
} from './alertClasses/alertClasses';
import { ALERT_ICONS } from './alertIcons';

/**
 * `color` defaults to 'success'.
 *
 * Only errors are announced (`role='alert'`); they must interrupt, the others
 * can wait to be read.
 *
 * `icon={false}` drops the icon and its gap, for alerts that are a block of
 * prose where a glyph would read as a stray bullet.
 */
export const Alert = ({
  color = 'success',
  variant,
  icon,
  action,
  className,
  children,
}: {
  color?: AlertColor;
  variant?: AlertVariant;
  icon?: ReactNode | false;
  action?: ReactNode;
  className?: string;
  children: ReactNode;
}) => {
  const Icon = ALERT_ICONS[color];

  return (
    <div
      role={color === 'error' ? 'alert' : undefined}
      className={alertClasses({ color, variant, className })}
    >
      {icon !== false && (
        <div className={ALERT_ICON_CLASSES}>
          {icon ?? <Icon aria-hidden='true' />}
        </div>
      )}
      <div className={ALERT_MESSAGE_CLASSES}>{children}</div>
      {action !== undefined && (
        <div className={ALERT_ACTION_CLASSES}>{action}</div>
      )}
    </div>
  );
};
